// eslint-disable-next-line max-len
import { Person } from '@sdir/httpclient/lib/clients/core/search';
import { createContext } from 'react';
import { Loadable } from '../../types';

export interface ICurrentPersonContext {
  person: Loadable<Person>;
  refresh?: () => void;
}

export const CurrentPersonContext = createContext<ICurrentPersonContext>({
  person: {
    loading: false,
    result: null,
    error: null,
  },
});
